import getDefaultState from './state';

export function flush(state) {
  Object.assign(state, getDefaultState());
}

export function updateCurrentBooking(state, { booking }) {
  state.current = booking;
}

export function updateBookings(state, { bookings }) {
  state.all = bookings;
}

export function updateSlots(state, { slots }) {
  state.slots = slots;
}

export function updateFilter(state, { filter }) {
  state.filter = filter;
}

export function updateMeta(state, { meta }) {
  state.meta = meta;
}

export function updateSort(state, { sort }) {
  state.sort = sort;
}
